import React from "react";
import CloseDetailPage from "../../components/CloseComponent/CloseDetailPage";
import DetailWrapper from "../../components/detailWrapper";
import { Button } from "semantic-ui-react";
import { AiFillCheckCircle } from "react-icons/ai";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router";
import ResultPage from "../../components/ResultPage/ResultPage";
import QRCode from "qrcode.react";
import InputCopy from "../../components/CopyComponent/InputCopy";

const DepositSuccess = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`formHint.${key}`);
  const i18n_common = (key) => t(`common.${key}`);
  const i18n_deposit = (key) => t(`deposit.${key}`);

  // 从localStorage取得儲存的银行信息字符串
  const storedBankInfoString = localStorage.getItem("bankPaymentSelected");

  // 将存储的字符串解析为JavaScript对象
  const storedBankInfo = JSON.parse(storedBankInfoString);

  // 取銀行帳戶和銀行號碼
  const bankAcc = storedBankInfo?.bank_acc || "";
  const bankNum = storedBankInfo?.bank_num || "";
  const amount = localStorage.getItem("amounts");

  const navigate = useNavigate();

  return (
    <ResultPage
      buttonProps={{
        content: i18n("goToDepositData"),
        path: "../../profile/transaction",
      }}
      resultContent={`${i18n("youCanGo")} ${i18n("depositRoute")}，${i18n(
        "view"
      )}
  ${i18n("depositData")}`}
      resultText={i18n("depositSuccess")}
      pageType="success"
      pageTitle={i18n("depositSuccess")}
      CONTENT={
        <div>
          <div className="my-2">
            {i18n_deposit("bank_account")}
            <InputCopy copyLink={bankAcc} />
          </div>
          <div className="my-2">
            {i18n_deposit("bank_number")}
            <InputCopy copyLink={bankNum} />
          </div>
          <div className="my-2">
            {i18n_deposit("amount")}
            <InputCopy copyLink={amount} />
          </div>
          <div className="bg-hover-transaction-card dark:bg-base-light-dark rounded-b-[5px] py-[20px] flex items-center justify-center">
            <div className="bg-base-light-white dark:bg-base-light-dark p-[5px] text-center">
              <QRCode value={bankNum} renderAs="canvas" />
            </div>
          </div>
        </div>
      }
    />
  );
};

export default DepositSuccess;
